export default __webpack_public_path__ + "static/media/gal03.b13fb9f1.svg";